import _ from 'lodash';

export const extraParamsSelector = (state, params) => {
    if (!_.isObject(params)) {
        throw new Error(`Expected second selector parameter to be an object, instead got: ${params}`);
    }
    return params;
};
